export default "__VITE_ASSET__Dq6AliJU__"